module.exports = __webpack_public_path__ + "static/media/picklist_type.fe2325b6.svg";